// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"rivermini_animationWrapper__SG2Kb"};